import { render, staticRenderFns } from "./VideoGrid.vue?vue&type=template&id=4a3a2481&scoped=true&"
import script from "./VideoGrid.vue?vue&type=script&lang=js&"
export * from "./VideoGrid.vue?vue&type=script&lang=js&"
import style0 from "./VideoGrid.vue?vue&type=style&index=0&id=4a3a2481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a2481",
  null
  
)

export default component.exports